export default __webpack_public_path__ + "static/media/ic_tiktok.9f9e471c.svg";